module.exports = __webpack_public_path__ + "static/media/negative-ex.e88dee5c.png";